module.exports = __webpack_public_path__ + "static/media/RW.897b6802.svg";